import React from 'react';
import { DeactivateConfirmationModal } from './deactivate-confirmation-modal.component';
import { useDeactivateConfirmationModalService } from './deactivate-confirmation-modal.service';
import type { DeactivateConfirmationModalContainerProps } from './deactivate-confirmation-modal.types';

export const DeactivateConfirmationModalContainer = (
  props: DeactivateConfirmationModalContainerProps,
) => {
  const serviceProps = useDeactivateConfirmationModalService(props);
  return <DeactivateConfirmationModal {...serviceProps} />;
};
